<template>
  <section>
    <fixed-header :title="pageTitle" :listPage="'/rfp/parts'">
      <template v-slot:left>
        <info-data label="Date" :value="dateFilter(header[FIELDS.DATE_CREATED])" horizontal />
        <info-data label="Status" :value="header[FIELDS.STATUS_NAME]" horizontal />
        <b-button
          @click="onCloseRFP"
          type="submit"
          class="mr-4"
          size="sm"
          v-if="header.statusId === rfpStatus.OPEN"
          :disabled="isLoading"
        >
          <i v-if="isLoading" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Close
        </b-button>
        <b-button
          @click="onReopenRFP"
          type="submit"
          class="mr-4"
          size="sm"
          v-if="header.statusId === rfpStatus.CLOSED"
          :disabled="isLoading"
        >
          <i v-if="isLoading" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Open
        </b-button>
        <info-data label="Aging" horizontal>{{ aging }} day{{ aging > 1 ? 's' : '' }}</info-data>

        <info-data
          label="Date added"
          horizontal
        >{{ header[FIELDS.DATE_CREATED] | date }} by: {{ header[FIELDS.CREATED_BY_USER_FULL_NAME] }}</info-data>
        <info-data
          label="Last modified"
          horizontal
        >{{ header[FIELDS.DATE_MODIFIED] | date }} by: {{ header[FIELDS.MODIFIED_BY_USER_FULL_NAME] }}</info-data>
        <info-data
          label="Date sent"
          horizontal
        >
          <span
            v-if="header[FIELDS.DATE_SENT]"
          >{{ header[FIELDS.DATE_SENT] | date }} by: {{ header[FIELDS.SENT_BY_USER_FULL_NAME] }}</span>
        </info-data>

        <info-data
          label="Sales Person"
          horizontal
        >
          <b-form-select v-model="salesPersonId">
            <option
              v-for="(selectRep, indexRep) in sortSelect(salesReps)"
              :key="indexRep"
              :value="selectRep.id"
            >{{ selectRep.name }}</option>
          </b-form-select>
        </info-data>
        <b-button
          type="button"
          variant="primary"
          class="btn assign-person-button mr-4"
          size="sm"
          @click="onAssignSalesPerson"
          :disabled="!salesPersonId || isSaving"
        >
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Assign
        </b-button>
        <!-- <b-button @click="$bvModal.show('view-fast-report')" size="sm"><i class="fa fa-print"></i></b-button> -->
        <!-- <b-button @click="$emit('sendEmail')" class="ml-2" size="sm" variant="primary">Send Email</b-button> -->
      </template>
    </fixed-header>

    <!-- <b-modal id="view-report-modal" ref="view-report-modal" hide-footer>
      <report-viewer :filePath="'ReportsRoot/RequestForPricing.flxr'" :parameter="{ rfp: rfpId }" :reportName="'RequestForPricing'" />
    </b-modal> -->
    <!-- <report-viewer :reportName="'RequestForPricing'" :parameter="{ rfp: rfpId }" /> -->
    <!-- <fast-report-viewer :moduleName="'RFP'" :parameter="rfpId" /> -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

import reportApi from '@/resources/reportApi';

import { RFP_STATUS, REPORTS_CONSTANTS } from '@/shared/constants';

import { date } from '@/shared/filters';
import { FIELDS } from '@/pages/Rfp/components/RfpDetails/constants';

import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import ReportViewer from '@/shared/components/ReportViewer';
import FastReportViewer from '@/shared/components/FastReportViewer';


export default {
  components: {
    FixedHeader,
    ReportViewer,
    FastReportViewer
  },
  data: () => ({
    FIELDS,
    dateFilter: date,
    salesPersonId: null,
    rfpStatus: RFP_STATUS,
    printFilePath: null,
    isSaving:false,
    isLoading:false,
  }),
  computed: {
    ...mapGetters('rfpDetails', [
      'headerById',
      'salesReps',
    ]),
    rfpId() {
      return this.$route.params.id;
    },
    header() {
      return this.headerById(this.rfpId);
    },
    aging() {
      const now = moment();
      const createdAt = moment(this.header[this.FIELDS.DATE_CREATED]);

      return now.diff(createdAt, 'days');
    },
    pageTitle() {
      return `Quote Request List # ${this.header[FIELDS.ID]}`;
    },
  },
  watch: {
    salesReps() {
      let salesRepObj = this.salesReps.find(rep => rep.name === this.header.salesPersonFullName);
      if (salesRepObj != undefined) {
        this.salesPersonId = salesRepObj.id;
      }
    },
  },
  methods: {
    ...mapActions('rfpDetails', [
      'emailRfp',
      'assignSalesPerson',
      'updateRfpStatus',
      'getHeader',
    ]),
    async onAssignSalesPerson() {
      try {
        this.isSaving = true;
        await this.assignSalesPerson({rfpId: this.rfpId, salesPersonId: this.salesPersonId});
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
      }
    },
    async setRfpStatus(statusId) {
      await this.updateRfpStatus({ rfpId: this.rfpId, statusId: statusId });
      await this.getHeader(this.rfpId);
    },
    async onCloseRFP() {
      try {
        this.isLoading = true;
        await this.setRfpStatus(RFP_STATUS.CLOSED);
        this.isLoading = false;
      }catch (e) {
        this.isLoading = false;
      }
    },
    async onReopenRFP() {
      try {
        this.isLoading = true;
        await this.setRfpStatus(RFP_STATUS.OPEN);
        this.isLoading = false;
      }catch (e) {
        this.isLoading = false;
      }
    },
    async printReport() {
      const { data } = await reportApi.get("api/report/RFPReport/"+this.rfpId+"/$pdf", {
        name: 'document',
        responseType: 'blob'
      });

      console.log(data)

      // const fileUrl = URL.createObjectURL(data);
      // var a = document.createElement('a');
      // document.body.appendChild(a);
      // a.style = 'display: none';
      // a.href = fileUrl;
      // a.download = `RFPReport.pdf`;
      // a.click();
      // window.URL.revokeObjectURL(fileUrl);
      // document.body.removeChild(a);
    },
    async onPreviewPrintQuote() {
      this.$bvModal.show('view-report-modal');
    }
  },
  filters: {
    date,
  },
};
</script>

<style lang="scss">
.sales-person-container {
  margin-top: 15px;
}
</style>
